module.exports = __webpack_public_path__ + "img/82800.ef2d49f4.jpg";